import _ from 'lodash';
import {
  TOGGLE_PRIMARY_IMAGE_STATE,
  TRANSITION,
  TOGGLE_OPTION_SUCCESS,
  TOGGLE_OPTION_CONFLICT_RESOLVE
} from '../actionTypes';

function wasInteriorColorChange(payload) {
  var option = payload.option;
  var config = payload.fullConfig;
  var interiorColors = _.flatMap(config.colors.interior, 'items');
  return _.some(interiorColors, { id: option.id });
}

function wasExteriorColorChange(payload) {
  var option = payload.option;
  var config = payload.fullConfig;
  var interiorOptions = _.flatMap(config.colors.exterior, 'items');
  return _.some(interiorOptions, { id: option.id });
}

export default function isInteriorImagePrimary(state, action) {
  var payload = action.payload;

  switch (action.type) {
    case TOGGLE_PRIMARY_IMAGE_STATE:
      return !state;
    case TRANSITION:
      if (
        payload.to === 'INTERIOR' &&
        !_.startsWith(payload.from, 'INTERIOR')
      ) {
        return true;
      }
      if (
        payload.to === 'EXTERIOR' &&
        !_.startsWith(payload.from, 'EXTERIOR')
      ) {
        return false;
      }
      if (payload.to === 'CONFIG' && !_.startsWith(payload.from, 'CONFIG')) {
        return false;
      }
      return state;
    case TOGGLE_OPTION_SUCCESS:
    case TOGGLE_OPTION_CONFLICT_RESOLVE:
      if (wasInteriorColorChange(payload)) {
        return true;
      }
      if (wasExteriorColorChange(payload)) {
        return false;
      }
      return state;
    default:
      return state || false;
  }
}
